document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('callButton').addEventListener('click', copyToDialPad);
  });
  
  function copyToDialPad() {
    var phoneNumber = document.getElementById('phoneNumber').textContent;
    var tempTextArea = document.createElement('textarea');
    tempTextArea.value = phoneNumber;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    tempTextArea.setSelectionRange(0, 99999);
    document.execCommand('copy');
    document.body.removeChild(tempTextArea);
    window.open('tel:' + phoneNumber, '_blank');
  }